function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "arrow-line-short_inline_svg__Group_2104",
  "data-name": "Group 2104",
  transform: "translate(-116.239 -300.628)"
}, /*#__PURE__*/React.createElement("g", {
  id: "arrow-line-short_inline_svg__Union_13",
  "data-name": "Union 13",
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  id: "arrow-line-short_inline_svg__Union_13-2",
  "data-name": "Union 13",
  d: "M71.257 10L60.407 0l10.85 10 10.85-10-10.85 10zM82.11 0zM0 0z",
  transform: "translate(116.239 301.128)",
  fill: "rgba(0,0,0,0)"
}), /*#__PURE__*/React.createElement("path", {
  id: "arrow-line-short_inline_svg__Union_13_-_Outline",
  "data-name": "Union 13 - Outline",
  d: "M71.586 10.376L71.257 10l-.335.371.335-.371-.339.367L60.212.5H0v-1h60.405V0l.341-.37 10.511 9.689L81.768-.368 82.11 0v-.5h60.432v1H82.3l-10.7 9.867-.343-.367z",
  transform: "translate(116.239 301.128)",
  fill: "#fdf7ec"
})));

function SvgArrowLineShortinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 142.542,
    height: 10.876,
    viewBox: "0 0 142.542 10.876"
  }, props), _ref);
}

export default SvgArrowLineShortinline;